import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: {
    pagination: {
      page: 0,
      pageSize: 10,
    },
    search: "",
    fullName: "",
    country: { value: "", label: "" },
    city: { value: "", label: "" },
    talentPool: { value: "", label: "" },
    jobsCompleted: "",
    workedWith: "",
    backgroundCheck: "",
    certifications: { value: "", label: "" },
    equipment: { value: "", label: "" },
    skillSet: { value: "", label: "" },
  },
};

const freelanceCompanyWorkforceFiltersSlice = createSlice({
  name: "freelanceCompanyWorkforceFiltersSlice",
  initialState,
  reducers: {
    setFreelanceCompanyWorkforceFilters: (state, action) => {
      const { filterName, data } = action.payload;
      if (filterName === "pagination") {
        state.value.pagination = { ...state.value.pagination, ...data };
      } else {
        state.value[filterName] = data;
      }
    },
    resetFreelanceCompanyWorkforceFilters: (state) => {
      state.value = { ...initialState.value };
    },
    resetFreelanceCompanyWorkforcePagination: (state) => {
      state.value.pagination = { page: 0, pageSize: 10 };
    },
  },
});

export const {
  setFreelanceCompanyWorkforceFilters,
  resetFreelanceCompanyWorkforceFilters,
  resetFreelanceCompanyWorkforcePagination,
} = freelanceCompanyWorkforceFiltersSlice.actions;

export default freelanceCompanyWorkforceFiltersSlice.reducer;
